import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { adminAgentService, type AdminConversation } from '../../../../services/adminAgent.service';

export const CONVERSATIONS_QUERY_KEY = ['admin-agent', 'conversations'] as const;

/** The admin's past conversations with the assistant; fetched only while needed. */
export function useAdminConversations(enabled: boolean) {
  return useQuery({
    queryKey: CONVERSATIONS_QUERY_KEY,
    queryFn: () => adminAgentService.listConversations(),
    enabled,
    staleTime: 0,
  });
}

/** Renames a conversation and patches the cached list so every title on screen updates at once. */
export function useRenameConversation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: { conversationPublicId: string; title: string }) =>
      adminAgentService.renameConversation(input.conversationPublicId, input.title),
    onSuccess: (updated) =>
      queryClient.setQueryData<AdminConversation[]>(CONVERSATIONS_QUERY_KEY, (current = []) =>
        current.some((item) => item.conversationPublicId === updated.conversationPublicId)
          ? current.map((item) =>
              item.conversationPublicId === updated.conversationPublicId ? updated : item
            )
          : [updated, ...current]
      ),
  });
}
